import Icon from "../Icon/Icon";
import styles from "./IconButton.styles.scss";

const IconButton = ({iconName, onClick, clear, red, accent, badge}) => {
  return <button onClick={onClick} className={[styles.iconButton, clear && styles.iconButtonClear, red && styles.iconButtonRed, accent && styles.iconButtonAccent].join(" ")}>
    <Icon name={iconName} color={accent ? "#8BC34A" : "#fff"} badge={badge} />
  </button>;
};

export default IconButton;



// WEBPACK FOOTER //
// ./components/IconButton/IconButton.js